import React from 'react';
import { Modal, Tag, Tooltip } from 'antd';
import {
  Container,
  PreviewTemplateDetails
} from './styles';
import { dateConversion } from '../../utils/javascript';
import { useTranslation } from 'react-i18next';
import PrintTemplatePreview from '../PrintTemplatePreview';
import { DESIGN_AREA_TEMPLATES_TAB } from '../../containers/SidebarMenu/translationValues';

const NAMESPACES = ['DESIGN_AREA_TEMPLATES_TAB']
const PreviewModal = props => {
  const { visible, onCancel, targetTemplate, currentIndex, isMailTemplates } = props;
  const { t } = useTranslation(NAMESPACES);

  return (
    <Container>
      <Modal
        title={null}
        centered
        visible={visible}
        width="900px"
        onCancel={onCancel}
        style={{ padding: '0px !important' }}
        footer={null}
      >
        <PreviewTemplateDetails>
          <h2>{targetTemplate.name}</h2>
          <p>
            {targetTemplate.updatedOn
              ? t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDITED_ON.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDITED_ON.value) + dateConversion(targetTemplate.updatedOn, false)
              : t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDITED_ON.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDITED_ON.value) +  dateConversion(targetTemplate.createdOn, false)}
          </p>
          {targetTemplate.tags && (
            <div className="tags-div">
              {targetTemplate.tags.split(',').map(tag => {
                const isLongTag = tag.length > 20;
                const tagElement = (
                  <Tag className="edit-tag" key={tag} color="#df4c35">
                    <span>{isLongTag ? `${tag.slice(0, 20)}...` : tag}</span>
                  </Tag>
                );
                return isLongTag ? (
                  <Tooltip title={tag} key={tag}>
                    {tagElement}
                  </Tooltip>
                ) : (
                  tagElement
                );
              })}
            </div>
          )}
        </PreviewTemplateDetails>
        <PrintTemplatePreview
          targetTemplate={targetTemplate}
          currentIndex={currentIndex}
          isMailTemplates={isMailTemplates}
        />
      </Modal>
    </Container>
  );
};

export default PreviewModal;
